export default __webpack_public_path__ + "static/media/bruno.c339b568.jpg";